import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import * as _ from 'lodash';

/** Local values */
import { apiCalls } from '../utils/index';
/** Query file */
import { ReportReviewQueryService } from '../gql-query-mutation/index';

@Injectable()
export class AuthService implements Resolve<any>
{

    apiCalls = apiCalls;

    constructor(
        private http: HttpClient,
        private _reportReviewQueryService: ReportReviewQueryService
    ) {
    }

    /**
     * Resolve
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        return new Promise((resolve, reject) => {
            Promise.all([
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    // get single order
    getOrder(id: number): Promise<any> {

        return new Promise((resolve, reject) => {
            this.http.get(this.apiCalls.singleOrder + '?dev=true&order_id='
                + id + '&rand=' + Math.round(Math.random() * 999999999))
                .subscribe((response: any) => {
                    if (response.hasOwnProperty('status')) {
                        if (response.status === 'success') {
                            resolve(JSON.parse(response.message));
                        } else {
                            reject(response);
                        }
                    } else {
                        reject(response);
                    }
                }, (err) => {
                    reject(err);
                });
        });

    }

    // Check login 
    checkIsValidIdOnlogin(insId: string) {
        return new Promise((resolve, reject) => {
            this._reportReviewQueryService.doLogin(insId)
                .valueChanges
                .subscribe((res: any) => {

                    if (res && res.data &&
                        res.data.allReportReviewDetails &&
                        res.data.allReportReviewDetails.nodes.length > 0) {
                        resolve(res.data.allReportReviewDetails.nodes);
                    } else {
                        resolve([]);
                    }
                }, reject)

        })
    }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/auth/auth.service.ts